<h-places-search-bar
    (locationSelected)="locationSelected($event)"
    (geolocationButtonSelected)="geolocationButtonSelected.emit($event)"
    [isWorldwideResearch]="isWorldwideResearch"
    [forceInlineDisplay]="true">
</h-places-search-bar>
